module.exports = __webpack_public_path__ + "static/media/office5.18444c58.jpg";